import { Http } from '@angular/http';
import { Injectable } from '@angular/core';
import { Globals } from '../../../app/app.globals';

@Injectable()
export class ErrorLogService {

    constructor(private http: Http, private globals: Globals) {
        this.http = http;

    }

    public sendToServer(error: any): void {
        console.log('error', error);
        let errorObj = {
            message: 'Local Date => ' + new Date().toString() + '\n Error => ' + error.toString(),
            location: window.location.href,
            error_code: -1,
            entity_url: -1
        };
        if (error.stack && error.stack.toString()) {
            errorObj.message += '\n Stack Trace => ' + error.stack.toString()
        }
        this.http.post(this.globals.apiEndpoint + 'api/log-error', errorObj).subscribe((res) => { },
            (err) => { });
    }

}



// WEBPACK FOOTER //
// ./src/app/api/services/error.service.ts